import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { ComissaoAssuntoResponse } from './comissao-assunto.model';

@Injectable({ providedIn: 'root' })
export class ComissaoAssuntoService extends BaseService {
    readonly PATH = environment.basePath + '/comissoes/configuracoes/assuntos';
    private assuntos$?: Observable<ComissaoAssuntoResponse[]>;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /**
     * Lista todos os assuntos (formato plano com id/id_pai/descrição para montagem
     * da árvore). O resultado é cacheado e compartilhado entre os consumidores
     * (uma requisição por sessão); em caso de erro o cache é descartado.
     */
    listarAssuntos(): Observable<ComissaoAssuntoResponse[]> {
        if (!this.assuntos$) {
            this.assuntos$ = this.http.get<ComissaoAssuntoResponse[]>(this.PATH).pipe(
                catchError((err) => {
                    this.assuntos$ = undefined;
                    return throwError(() => err);
                }),
                shareReplay({ bufferSize: 1, refCount: false })
            );
        }
        return this.assuntos$;
    }
}
